import { createTheme } from '@mui/material/styles'

import Colors from '#/styles/Colors'
import componentsOverrides from '#/styles/Overrides'
import { typography } from '#/styles/typography'

export default () => {
  const themeOptions = {
    typography,
    palette: Colors.theme.colors,
  }

  const theme = createTheme(themeOptions)
  theme.components = componentsOverrides(theme)

  return theme
}
